import React from "react";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

export default function DialogObjetivoV2Catalogo({
  open,
  onClose,
  titulo,
  label,
  valor,
  setValor,
  onGuardar,
  loading,
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{titulo}</DialogTitle>

      <DialogContent dividers>
        <MDBox mt={1}>
          <MDInput
            label={label}
            fullWidth
            value={valor}
            onChange={(e) => setValor(e.target.value)}
            onBlur={() =>
              setValor((prev) =>
                String(prev || "")
                  .trim()
                  .toUpperCase()
              )
            }
          />
        </MDBox>
      </DialogContent>

      <DialogActions>
        <MDButton color="secondary" onClick={onClose}>
          Cancelar
        </MDButton>

        <MDButton color="info" onClick={onGuardar} disabled={loading}>
          Guardar
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}
